export default __webpack_public_path__ + "static/media/hc-login.7f56dce7.jpg";